import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Keeps a signed-in user off /login.
 *
 * SYNCHRONOUS, and that is the whole point. It reads the in-memory flag and
 * NEVER awaits the network, so a cold load of /login paints with zero network
 * dependency - which is the fast-login requirement, expressed as code. Calling
 * `ensureSession()` here would put a refresh round trip in front of the first
 * paint of the one route that must never wait for the API.
 *
 * The consequence is deliberate: a user with a live refresh cookie who types
 * /login directly gets the login screen instead of being bounced to /app. That
 * is a fast, correct, sign-in-again screen rather than a blank one, and
 * signing in from it is idempotent.
 */
export const guestGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  if (!auth.isAuthenticated()) return true;
  return inject(Router).createUrlTree(['/app']);
};
